export const isLocal = window.location.hostname === "localhost";
export const isProduction = process.env.NODE_ENV === "production";
